import { useEffect, useState } from "react";

export function loadFilterState(storageKey) {
  try {
    const raw = sessionStorage.getItem(storageKey);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export function useLogsFilters(storageKey) {
  const [_saved] = useState(() => loadFilterState(storageKey));

  const [showFilter, setShowFilter] = useState(true);
  const [selectedDateRange, setSelectedDateRange] = useState(
    _saved.selectedDateRange ?? {}
  );
  const [selectedType, setSelectedType] = useState(
    _saved.selectedType ?? undefined
  );
  const [selectedSubject, setSelectedSubject] = useState(
    _saved.selectedSubject ?? undefined
  );
  const [selectedCoachNames, setSelectedCoachNames] = useState(
    _saved.selectedCoachNames ?? undefined
  );
  const [selectedNames, setSelectedNames] = useState(
    _saved.selectedNames ?? undefined
  );
  const [selectedStatus, setSelectedStatus] = useState(
    _saved.selectedStatus ?? undefined
  );
  const [searchKey, setSearchKey] = useState(_saved.searchKey ?? "");
  const [searchInputValue] = useState(_saved.searchKey ?? "");

  useEffect(() => {
    sessionStorage.setItem(
      storageKey,
      JSON.stringify({
        showFilter,
        selectedDateRange,
        selectedType,
        selectedSubject,
        selectedCoachNames,
        selectedNames,
        selectedStatus,
        searchKey,
      })
    );
  }, [
    storageKey,
    showFilter,
    selectedDateRange,
    selectedType,
    selectedSubject,
    selectedCoachNames,
    selectedNames,
    selectedStatus,
    searchKey,
  ]);

  const clearAll = () => {
    setSelectedDateRange({});
    setSelectedType(undefined);
    setSelectedSubject(undefined);
    setSelectedCoachNames(undefined);
    setSelectedNames(undefined);
    setSelectedStatus(undefined);
    setSearchKey("");
    setShowFilter(false);
  };

  return {
    showFilter,
    setShowFilter,
    selectedDateRange,
    setSelectedDateRange,
    selectedType,
    setSelectedType,
    selectedSubject,
    setSelectedSubject,
    selectedCoachNames,
    setSelectedCoachNames,
    selectedNames,
    setSelectedNames,
    selectedStatus,
    setSelectedStatus,
    searchKey,
    setSearchKey,
    searchInputValue,
    clearAll,
  };
}
